import UserManagementTable from './UserManagementTable';
// Temporarily hidden
// import UserStatsCards from './UserStatsCards';

const UsersDashboard = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground">Users Management</h2>
        <p className="text-muted-foreground">
          Manage all users, their roles, and view their subscription details
        </p>
      </div>

      {/* Temporarily hidden KPI cards (Total Users, Active Subs, Plan Types, Mailchimp Sync) */}
      {/* <UserStatsCards /> */}

      <div className="bg-card rounded-lg border border-border p-6">
        <UserManagementTable />
      </div>
    </div>
  );
};

export default UsersDashboard;